import React, { useEffect, useState } from 'react'
import SearchBar from '../../components/Schedule/Preview/searchBar'
import Layout from '../../components/common/pageLayout'
import StatsCard from '../../components/Schedule/Preview/statsCard'
import List from '../../components/Schedule/Preview/list'
import { v3_delete_schedule_event, v3_search_schedule, v3_update_schedule_event } from '../../actions/v3/schedule'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { toast } from 'react-toastify'
import constant from '../../constant'
import PastEvents from '../../components/Schedule/Preview/pastEvents'
import ExportColumnModal from '../../components/common/ExportColumnModal'
import { exportRowsToExcel, replacePageState } from '../../utils'

const scheduleExportColumns = [
    { key: 'serialNo', label: 'S No.', value: (event, index) => index + 1 },
    { key: 'project', label: 'Project', value: (event) => event.PROJECT_NAME },
    { key: 'ship', label: 'Ship', value: (event) => event.SHIP_NAME },
    { key: 'hullNumber', label: 'Hull Number', value: (event) => event.HULL_NUMBER },
    { key: 'category', label: 'Category', value: (event) => event.CATEGORY_NAME },
    { key: 'event', label: 'Event', value: (event) => event.EVENT_TYPE },
    { key: 'startDate', label: 'Start Date', value: (event) => event.START_DATE },
    { key: 'endDate', label: 'End Date', value: (event) => event.END_DATE },
    { key: 'note', label: 'Note', value: (event) => event.NOTE },
    { key: 'createdOn', label: 'Created On', value: (event) => event.CREATED_ON },
    { key: 'createdBy', label: 'Created By', value: (event) => event.CREATED_BY_NAME },
];
const Preview = (props) => {

    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(page || 1);
    const [limit, setLimit] = useState(10);
    const [payload, setPayload] = useState('');
    const [refresh, setRefresh] = useState(false);
    const [pastEventFilter, setPastEventFilter] = useState('All');
    const [pastEventPage, setPastEventPage] = useState(1);
    const [pastEventLimit, setPastEventLimit] = useState(4);
    const [pastEventList, setPastEventList] = useState([]);
    const [deletingEventId, setDeletingEventId] = useState(null);

    useEffect(() => {
        setPastEventList([]); // reset list when payload or filter changes
    }, [payload, pastEventFilter]);

    useEffect(() => {
        v3_search_schedule(currentPage, limit, payload, pastEventFilter, pastEventPage, pastEventLimit).then((res) => {
            if (res.status) {
                console.log(res.result)
                setData(res.result);
                setPastEventList(prevList => {
                    const existingIds = new Set(prevList.map(item => item.ID)); // assuming 'id' is unique
                    const newEvents = res.result.pastEvents.data.filter(item => !existingIds.has(item.ID));
                    return [...prevList, ...newEvents]; // maintain order: old + new
                });
                replacePageState(props.history, constant.Authedcomponent.schedulePreview.url, {
                    page: currentPage
                });
            } else {
                toast.error(res.error);
            }
        });
    }, [currentPage, limit, refresh, pastEventFilter, pastEventPage, pastEventLimit]);

    useEffect(() => {
        v3_search_schedule(1, limit, payload, pastEventFilter, pastEventPage, pastEventLimit).then((res) => {
            if (res.status) {
                setData(res.result);
                setPastEventList(prevList => {
                    const existingIds = new Set(prevList.map(item => item.ID)); // assuming 'id' is unique
                    const newEvents = res.result.pastEvents.data.filter(item => !existingIds.has(item.ID));
                    return [...prevList, ...newEvents]; // maintain order: old + new
                });
                replacePageState(props.history, constant.Authedcomponent.schedulePreview.url, {
                    page: 1
                });
            } else {
                toast.error(res.error);
            }
        });
    }, [payload]);

    const onUpdateEvent = (model) => {
        v3_update_schedule_event(model).then((res) => {
            if (res.status) {
                setRefresh(!refresh)
                toast.success(res.result.message)
                handleCloseModal(model.scheduleId)
            }
            else {
                toast.error(res.error);
            }
        })
    }

    const onDeleteEvent = (event) => {
        if (deletingEventId) return;
        if (!window.confirm(`Delete the ${event.EVENT_TYPE} schedule event? This cannot be undone from the schedule.`)) return;

        setDeletingEventId(event.ID);
        v3_delete_schedule_event(event.ID).then((res) => {
            if (res.status) {
                setPastEventList([]);
                setPastEventPage(1);
                setRefresh((value) => !value);
                toast.success(res.result?.message || 'Schedule event deleted successfully.');
            } else {
                toast.error(res.error?.message || res.error || 'Failed to delete schedule event.');
            }
        }).catch(() => {
            toast.error('Failed to delete schedule event.');
        }).finally(() => setDeletingEventId(null));
    }

    const handleCloseModal = (id) => {
        // const modal = window.bootstrap.Modal.getInstance(document.getElementById(`eventUpdateModal-${id}`));
        const modal = window.bootstrap.Modal.getInstance(document.getElementById(`eventUpdateModal`));
        if (modal) {
            modal.hide();
        }
    };
    const downloadRecords = (selectedColumns = scheduleExportColumns) => {
        const { pagination } = data;
        const { total } = pagination;
        v3_search_schedule(1, total, payload, pastEventFilter, pastEventPage, pastEventLimit).then((res) => {
            if (res.status && res.result.data?.length > 0) {

                exportRowsToExcel({
                    rows: res.result.data,
                    columns: selectedColumns,
                    sheetName: 'Event Schedule',
                    fileName: 'Event_Schedule.xlsx',
                });
            } else {
                toast.error('No data available for download');
            }
        }).catch(() => {
            toast.error('Download failed. Please try again.');
        });
    };

    return (
        <>
            <Layout
                title='Schedules'
                nonCardVersion={true}
            >
                <SearchBar
                    onSearch={(encodedPayload) => { setPayload(encodedPayload) }}
                />
                {/* <StatsCard /> */}
                <div className="row" style={{ minHeight: 'calc(100vh - 150px)' }}>
                    <div className="col-lg-8 d-flex flex-column">
                        <div className="card flex-grow-1 d-flex flex-column" style={{ minHeight: 0 }}>
                            <List
                                record={data}
                                onUpdateEvent={onUpdateEvent}
                                onDeleteEvent={onDeleteEvent}
                                deletingEventId={deletingEventId}
                                setCurrentPage={setCurrentPage}
                            />
                            <ExportColumnModal
                                modalId="schedule-export-columns-modal"
                                title="Select Schedule Columns"
                                columns={scheduleExportColumns}
                                onExport={downloadRecords}
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 d-flex flex-column">
                        <div className="card flex-grow-1 d-flex flex-column"
                            style={{
                                minHeight: 0,
                                // maxHeight: 'calc(100vh - 150px)',
                                overflowX: 'hidden',
                                overflowY: 'hidden'

                            }}>
                            <PastEvents
                                page={data?.pastEvents?.pagination?.page}
                                total={data?.pastEvents?.pagination?.total}
                                limit={data?.pastEvents?.pagination?.limit}
                                setPage={setPastEventPage}
                                data={pastEventList}
                                // data={data?.pastEvents?.data || []}
                                filter={pastEventFilter}
                                setFilter={setPastEventFilter}
                            />
                        </div>
                    </div>
                </div>

            </Layout>

        </>
    )
}

export default Preview
